module.exports = __webpack_public_path__ + "img/skill-hub.c7441139.svg";